import { createAction } from '@ngrx/store';

export const Notifications = {
  load: createAction('[NOTIFICATIONS] LOAD'),
  loaded: createAction('[NOTIFICATIONS] LOADED', (entities: any) => ({ entities })),
  markAsRead: createAction('[NOTIFICATIONS] MARK AS READ', (uuid: string) => ({ uuid })),
  deleteAll: createAction('[NOTIFICATIONS] DELETE ALL'),
  markAsDeleted: createAction('[NOTIFICATIONS] MARK AS DELETED', (uuid: string) => ({ uuid })),
};
